import { Tooltip, Typography, Box } from "@mui/material";

const TruncatedText = ({ text, maxWords = 3, variant = "body2" }) => {
  if (!text) return <>--</>;

  const words = text.trim().split(/\s+/);
  const isTruncated = words.length > maxWords;

  const displayText = isTruncated
    ? words.slice(0, maxWords).join(" ") + "…"
    : text;

  return (
    <Tooltip
      title={isTruncated ? text : ""}
      arrow
      disableHoverListener={!isTruncated}
    >
      <Box
        sx={{
          maxWidth: 180,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          cursor: isTruncated ? "pointer" : "default",
        }}
      >
        <Typography variant={variant} noWrap>
          {displayText}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default TruncatedText;
